import {useEffect, useLayoutEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import routes from '../../../../../../../Routes/routes';
import {ATTENDANCE_GEOFENCES_MODEL,CREATE_STEP} from '../Model/Model';
import HandleChange from '../../../../../../../Helpers/HandleChange';
import {DEFAULT_LATITUDE, DEFAULT_LONGITUDE, errorMsg, getGeolocation} from "../../../../../../../Apis/functions";
import {toast} from "react-toastify";
import {CreateGeofence} from "../../../../../../../reduxToolkit/AttendanceGeofence/AttendanceGeofenceApi";
import {areTimesEqual, isCloseTimeNotValid} from "../../../../../Traffic/Manage/Model/Model";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CreateGeofenceAttendanceApp = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    let {state} = location;
    const [selectedList, setSelectedList] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [emptyFields, setEmptyFields] = useState(false);
    const [steps, setSteps] = useState([]);
    const [item, setItem] = useState({ ...ATTENDANCE_GEOFENCES_MODEL });
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const [dayArray, setDayArray] = useState([]);
    const [geofences, setGeofences] = useState([]);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [latitude, setLatitude] = useState(DEFAULT_LATITUDE);
    const [longitude, setLongitude] = useState(DEFAULT_LONGITUDE);
    const isCloseTimeInvalid = isCloseTimeNotValid(item.opening, item.closing);
    const isEqualTimes = areTimesEqual(item.opening, item.closing);

    useLayoutEffect(() => {
        getGeolocation({ setLatitude, setLongitude });
        setSteps([t('details'), t('active_schedule'), t('define_area'), t('summary')]);
    }, [permission, t]);

    useEffect(() => {
        setItem(prev => ({
            ...prev,
            devices: selectedList
        }));
    }, [selectedList]);

    // Validate required fields for the current step
    const handleStepSetUp = () => {
        let isEmpty;
        switch (activeStep) {
            case CREATE_STEP.DETAILS:
                isEmpty = !item.isValidDetails();
                break;
            case CREATE_STEP.ACTIVE_SCHEDULE:
                isEmpty = !item.isValidSchedule(dayArray);
                break;
            case CREATE_STEP.DEFINE_AREA:
                isEmpty = !item.isValidArea(geofences);
                break;
            default:
                isEmpty = false;
        }
        setEmptyFields(isEmpty);
        return !isEmpty;
    };

    /**
     * Update the currently active step in the creation wizard.
     */
    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    /**
     * Handle geofence creation submission.
     * Validates all steps before generating the request body.
     */
    const handleAdd = () => {
        setEmptyFields(false);
        if (!item.isValidDetails() || !item.isValidSchedule(dayArray) || !item.isValidArea(geofences)) {
            setEmptyFields(true);
            return;
        }
        dispatch(CreateGeofence(item.toRegister(geofences[0].coordinates, dayArray))).then(({ payload: { data: { success, code } } }) => {
            if (success) {
                toast.success(t('has_been_created_successfully'));
                navigate(routes.attendance.main, { state })
            } else {
                errorMsg(code);
            }
        });
    };

    const handleOnBack = () => {
        navigate(
            routes.attendance.main, {
                state: state
            });
    }

    return {
        t,
        activeStep,
        setActiveStep,
        steps,
        handleStepChange,
        handleStepSetUp,
        setDayArray,
        dayArray,
        handleAdd,
        item,
        emptyFields,
        handleChange,
        setItem,
        geofences,
        setGeofences,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        handleOnBack,
        selectedList,
        setSelectedList,
        isCloseTimeInvalid,
        isEqualTimes
    };
};

export default CreateGeofenceAttendanceApp;
